/* import __COLOCATED_TEMPLATE__ from './crossing-stats-selector.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

/**
 * CrossingStatsSelector Component
 *
 * Dropdown menu for toggling crossing stat visibility.
 * Displays stats grouped by category with checkboxes.
 *
 * @param {Function} onClose - Called when selector should close
 */
export default class CrossingStatsSelectorComponent extends Component {
  @service preferences;

  get allStats() {
    return this.preferences.getAvailableCrossingStats();
  }

  get visibleStats() {
    return this.preferences.getCrossingStatsConfig();
  }

  get positionStats() {
    return this.allStats.filter(s => s.group === 'position');
  }

  get comparativeStats() {
    return this.allStats.filter(s => s.group === 'comparative');
  }

  get classStats() {
    return this.allStats.filter(s => s.group === 'class');
  }

  get alwaysVisibleStats() {
    return this.allStats.filter(s => s.alwaysVisible);
  }

  @action
  handleToggle(statId) {
    this.preferences.toggleCrossingStat(statId);
  }

  @action
  handleBackdropClick(event) {
    if (event.target.classList.contains('column-selector-backdrop')) {
      this.args.onClose?.();
    }
  }

  @action
  handleClose() {
    this.args.onClose?.();
  }

  @action
  handleKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.args.onClose?.();
    }
  }

  @action
  setupKeyboardListener() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  @action
  teardownKeyboardListener() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
